import React, { forwardRef, useImperativeHandle, useMemo, useRef } from "react";
import styled from 'styled-components';
import moment from 'moment'
import NextBtn from './next';

const Page1 = ({ data, onNext }, ref) => {

  const containerRef = useRef();

  useImperativeHandle(ref, () => {
    return {
      shareContainer() {
        return containerRef.current
      }
    }
  })

  const formatDate = useMemo(() => {
    const date = data.earliestLoginTime;
    if (!date) {
      return ''
    }
    const month = moment(data.earliestLoginTime).month() + 1;
    const day = moment(data.earliestLoginTime).date();
    const minute = moment(data.earliestLoginTime).format('HH:mm')
    return {
      month,
      day,
      minute
    }
  }, [data]);

  return (
    <Container className="page page1" ref={containerRef}>
      <div className="data-wrap">
        <div className="user-data">2025这一年</div>
        <div className="user-data">
          你在市值风云活跃了
          <span className="light-data">{data.activeDays}</span>
          天
        </div>
        <div className="user-data">
          超越了全平台<span className="light-data">{data.activeX}%</span>用户
        </div>
        {!!formatDate && <div className="user-data">
          在<span className="light-data">{formatDate.month}</span>月<span className="light-data">{formatDate.day}</span>日<span className="light-data"> {formatDate.minute}</span>你与我们本年度首次相遇
        </div>}
        <div className="user-data">
          市值风云成长路上，感谢一路有你！
        </div>
        <img className="award-tip" src="https://file.wogoo.com/image/activity/active_205/award-tip@2x.png" alt="" />
      </div>

      <div className="data-bg">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/page1-bg@2x.png" alt=""/>
      </div>
      <div className="data-bg">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/bottom-arrow@2x.png" alt=""/>
      </div>
      <div className="page-logo">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/page-logo@2x.png" alt=""/>
      </div>
      <NextBtn onClick={onNext} />
    </Container>
  )
}

const Container = styled.div`
  
`;

export default React.memo(forwardRef(Page1));


// WEBPACK FOOTER //
// ./src/views/activity_205/page1.js